'use strict';
import React from 'react';
import NavBar from '../../components/navBar';
import SideMenu from '../../components/sideMenu';
import Loading from '../../components/loading';
import menuAction from '../../actions/menuAction';
import filterAction from '../../actions/filterAction';
import filterStore from '../../stores/filterStore';
import condoSetAction from '../../actions/condoSetAction';
import condoSetStore from '../../stores/condoSetStore';
import CondoCheckListForm from './condoCheckListForm';
import ContractorForm from './contractorForm';
import ModalCondo from './modalCondo';

class CondoNewForm extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);

        this.handleEdit = this.handleEdit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.callBack = this.callBack.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.state = {
            staffs: filterStore.getState().staffs,
            processingFilter: filterStore.getState().processing,
            iniLoadStaff: filterStore.getState().iniLoadStaff,
            condos: filterStore.getState().condos,
            iniLoadCondo: filterStore.getState().iniLoadCondo,
            iniLoadContractor: filterStore.getState().iniLoadContractor,
            contractors: filterStore.getState().contractors,

            condo: condoSetStore.getState().condo,
            checkList: condoSetStore.getState().checkList,
            processing: condoSetStore.getState().processing,
            warningMsg: "",
            modalClose: false,
        };
    }
    static defaultProps = {
        statusTxt: ["Active", "In-Active"]
    };
    componentDidMount() {
        condoSetStore.listen(this.onChange);
        filterStore.listen(this.onFilterChange);

        condoSetAction.clear();
        if (!this.state.processing) {
            condoSetAction.processing(true);
            //get checklist
            condoSetAction.getCheckList();
        }



        if (!this.state.processingFilter && !this.state.iniLoadStaff) {
            filterAction.processing(true);
            filterAction.getEmployee();
        }
        if (!this.state.iniLoadCondo) {
            filterAction.getCondoList();
        }
        //get Contractor
        if (!this.state.iniLoadContractor) {
            filterAction.getContractors();
        }

        menuAction.pageNumber({ selectedActivity: -1, selectedCategory: 0 });
    }
    componentWillUnmount() {
        filterStore.unlisten(this.onFilterChange);
        condoSetStore.unlisten(this.onChange);
    }
    onChange(state) {
        this.setState({
            condo: state.condo,
            checkList: state.checkList,
            processing: state.processing
        });
    }
    onFilterChange(state) {
        this.setState({
            staffs: state.staffs,
            processingFilter: state.processing,
            iniLoadStaff: state.iniLoadStaff,
            iniLoadCondo: state.iniLoadCondo,
            condos: state.condos,
            iniLoadContractor: state.iniLoadContractor,
            contractors: state.contractors
        });
    }
    callBack() {
        if (this.state.processing) return;
        //check if coordinate is correct or not
        if (this.state.condo.geoLocation.coordinates[0] < -180 || this.state.condo.geoLocation.coordinates[0] > 180 ||
            this.state.condo.geoLocation.coordinates[1] < -90 || this.state.condo.geoLocation.coordinates[1] > 90) {
            return this.setState({ warningMsg: "The Geo Location is out of bound. Please check the longitude and latitude" });
        }
        if (this.state.condo.postal == "") {
            return this.setState({ warningMsg: "Postal code cannot be empty" });
        }

        condoSetAction.processing(true);
        condoSetAction.removeCondo(this.state.condo);
        this.shouldModalClose(false);
    }
    shouldModalClose(data) {
        this.setState({
            modalClose: data
        });
    }
    handleChange(e) {
        let s = this.state.condo;
        let index = parseInt(e.target.getAttribute("data-index"));

        if (index == 0) {
            s.manageBy = { staffId: e.target.value };
        } else {
            s.supervisor = { staffId: e.target.value };
        }

        condoSetAction.condo(s);
    }
    handleClick(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        if (index == 0) {
            if (this.props.processing) return;
            condoSetAction.processing(true);
            condoSetAction.addCondo(this.state.condo);
        } else {
            this.props.history.push('/contractorSetting');
        }
    }
    handleEdit(e) {
        let index = parseInt(e.target.getAttribute('data-index'));

        let value = e.target.value;
        let s = this.state.condo;

        switch (index) {
            case 0:
                s.mcst = value;
                break;
            case 1:
                s.condoName = value;
                break;
            case 2:
                s.noUnit = parseInt(value);
                break;
            case 3:
                s.geoLocation.coordinates[0] = parseFloat(value);
                break;
            case 4:
                s.geoLocation.coordinates[1] = parseFloat(value);
                break;
            case 5:
                s.address = value;
                break;
            case 6:
                s.postal = value;
                break;
            case 7:
                s.radius = parseInt(value);
                break;
            case 8:
                s.status = parseInt(value);
                break;
        }

        condoSetAction.condo(s);

    }
    renderStaff() {
        return this.state.staffs.map((staff, index) => {
            return (
                <option value={staff.staffId} key={index}>{staff.userName}</option>
            );
        })
    }
    renderStatusOption() {
        return this.props.statusTxt.map((status, index) => {
            return (
                <option value={index} key={index}>{status}</option>
            );
        });
    }
    render() {
        let s = this.state.condo;

        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <Loading {...this.props} processing={this.state.processing || this.state.processingFilter} />
                    <div className=" col-md-10  col-sm-8 us-form">
                        <div className="contractorSet-form">
                            <div className="row">
                                <div className="col-md-4">
                                    <h4><b>Estate Details</b></h4>
                                    <div className="form-group">
                                        <label htmlFor="mcst">MCST</label>
                                        <input type="text" className="form-control" value={s.mcst} id="mcst"
                                            placeholder="Type MCST here" data-index="0" onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="condoName">Estate Name</label>
                                        <input type="text" className="form-control" value={s.condoName} id="condoName"
                                            placeholder="Type Estate Name here" data-index="1" onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="noUnit">No of Units</label>
                                        <input type="number" className="form-control" value={s.noUnit} id="noUnit"
                                            placeholder="" data-index="2" onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label id="geoLocation">Geo Location</label>
                                        <input type="number" className="form-control us-un" value={s.geoLocation.coordinates[1]} id="lat"
                                            placeholder="lattitude" data-index="4" onChange={this.handleEdit} />
                                        <input type="number" className="form-control us-un" value={s.geoLocation.coordinates[0]} id="lng"
                                            placeholder="longitude" data-index="3" onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="radius">Radius (meter)</label>
                                        <input type="number" className="form-control" value={s.radius} id="radius"
                                            placeholder="" data-index="7" onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="address">Address</label>
                                        <input type="text" className="form-control" value={s.address} id="address"
                                            placeholder="" data-index="5" onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="postal">Postal</label>
                                        <input type="text" className="form-control" value={s.postal} id="postal"
                                            placeholder="" data-index="6" onChange={this.handleEdit} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="status">Status</label>
                                        <select className="form-control" id="status" data-index="8" value={s.status} onChange={this.handleEdit}>
                                            {this.renderStatusOption()}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label htmlFor="postal">ManageBy</label>
                                        <select className="form-control atd-sel" name="employee" data-index="0" onChange={this.handleChange} value={s.manageBy.staffId}>
                                            <option value="" ></option>
                                            {this.renderStaff()}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="postal">Reporting Manager</label>
                                        <select className="form-control atd-sel" name="employee" data-index="1" onChange={this.handleChange} value={s.supervisor.staffId}>
                                            <option value="" ></option>
                                            {this.renderStaff()}
                                        </select>
                                    </div>
                                    <ContractorForm condo={this.state.condo} contractors={this.state.contractors} processing={this.state.processing} />
                                </div>
                                <div className="col-sm-4">
                                    <CondoCheckListForm checkList={this.state.checkList} condo={this.state.condo} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="warning">{this.state.warningMsg}</div>
                                    <button type="button" className="btn btn-warning us-cr"
                                        data-index="0" onClick={this.handleClick}>Create</button>
                                    <button type="button" className="btn btn-default us-cr"
                                        data-index="1" onClick={this.handleClick}>Cancel</button>
                                </div>
                                <div className="clear"></div>
                            </div>
                            <ModalCondo modalClose={this.state.modalClose} shouldModalClose={this.shouldModalClose} callBack={this.callBack} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default CondoNewForm;


// WEBPACK FOOTER //
// ./app/setComponents/condoSetComponents/condoNewForm.js